/**
 * MUI theme configuration matching Mercury's Vuetify 1.5 appearance.
 * Used as the single source of truth for all React component styling.
 */
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        primary: {
            main: "#1976D2",
        },
        secondary: {
            main: "#424242",
        },
        error: {
            main: "#FF5252",
        },
        warning: {
            main: "#FFC107",
        },
        info: {
            main: "#2196F3",
        },
        success: {
            main: "#4CAF50",
        },
        background: {
            default: "#fafafa",
        },
    },
    typography: {
        fontFamily: "'Roboto', sans-serif",
        fontSize: 14,
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
            styleOverrides: {
                root: {
                    textTransform: "uppercase",
                },
            },
        },
        MuiCard: {
            defaultProps: {
                variant: "outlined",
            },
        },
        MuiTextField: {
            defaultProps: {
                variant: "standard",
            },
        },
        MuiSelect: {
            defaultProps: {
                variant: "standard",
            },
        },
        MuiAutocomplete: {
            defaultProps: {
                size: "small",
            },
        },
        MuiCheckbox: {
            defaultProps: {
                color: "primary",
            },
        },
    },
});

export default theme;
